import React from "react";

const formatDateTime = (value?: string) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const tabConfig = [
  {
    columnTitle: "Title",
    dataField: ["title"],
  },
  {
    columnTitle: "Goal",
    dataField: ["goal"],
  },
  {
    columnTitle: "Starts",
    dataField: ["component"],
    component: ({ values }: { values: any }) => (
      <span>{formatDateTime(values.startTime)}</span>
    ),
  },
  {
    columnTitle: "Recurring",
    dataField: ["component"],
    component: ({ values }: { values: any }) => (
      <span>{values?.recurrence?.isActive ? "Weekly" : "One-time"}</span>
    ),
  },
  {
    columnTitle: "Status",
    dataField: ["status"],
  },
];

export default tabConfig;
